import { CurrentUser } from "../../components/login/CurrentUser";
import { IQueryParams } from "../../interfaces/type1/IQueryParams";
import { Identification } from "./Identification";
import SocketClient from "./SocketClient";

interface IDataBody extends IQueryParams {
    Identification?: Identification;
    ClientId?: string;
}

export class Message
{
    public Event: string;
    public To: string;
    public From: string;
    public Data: IDataBody;
    

    constructor(event : string, data : IDataBody)
    {
        this.To = SocketClient.DOCWindowsIdentification?.ID ?? "";
        this.From = SocketClient.ID ?? "";
        this.Event = event;
        this.Data = data;
        this.Data.Identification = new Identification(CurrentUser?.User?.Licence?.Number ?? "", CurrentUser?.User?.Name ?? "");
        this.Data.ClientId = SocketClient.ID;
    }

    public static IsMessage(object: any): boolean
    {
        return 'Event' in object && 'Data' in object;
    }

    public ToJSON(): string
    {
        return JSON.stringify(this);
    }
}